import {useMutation, useQueryClient} from "@tanstack/react-query";
import {createEditEvent} from "../services/apiEvents.js";

export function useCreateEvent() {
    
    const queryClient = useQueryClient();
    const {mutate: createEvent, isLoading: isCreating} = useMutation({
        mutationFn: createEditEvent,
        onSuccess: () => {
            alert("New event created successfully");
            queryClient.invalidateQueries({
                queryKey: ["events"],
            }).then(r => console.log(r));
        },
        onError: (error) => {
            console.error("Error creating event:", error);
            alert("Error creating event: " + error.message);
        },
    })
    
    return {isCreating, createEvent};
}